import request from '@/utils/request'
// 员工详情
export function userInfoData(id) {
  return request({
    url: `/sys/user/info/${id}`,
    method: 'get'
    
  })
}
// 员工新增修改
export function userInfo(data) {
  return request({
    url: `/sys/user/${
      !value.userId ? "save" : "update"
    }`,
    method:'post',
    data
  })
}
// 员工删除
export function userDelete(data) {
  return request({
    url: '/sys/user/delete',
    method: 'post',
    data
  })
}